import { atom } from 'jotai';

export const feedbackDialogAtom = atom<boolean>(false);
